import React from 'react'
import {useSelector} from 'react-redux'
import {seoTypeSelector} from '../selectors'
import Tabs from '../../common/Tabs'

export default function SeoTabsContainer() {
    const tabs = useSelector((state) => seoTypeSelector(state, 'tabsBlock'))

    return <Tabs tabs={tabs} />
}
